$(document).ready(function () {
  const menuItem = $('.slide-menu-item');

  const swiper = new Swiper('.swiper', {
    speed: 0,
    loop: true,
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  setActiveSlide();

  menuItem.on('click', (event) => {
    const target = $(event.target);

    if (target.hasClass('active')) {
      return;
    }

    const activeIndex = target.data('index');

    setActiveSlide(activeIndex);
    swiper.slideToLoop(Number(activeIndex));
  });

  swiper.on('slideChange', function () {
    setActiveSlide(swiper.realIndex);
  });

  function setActiveSlide(index = 0) {
    $('.active[data-index]', '.industries-block').removeClass('active');
    $(`[data-index="${index}"]`, '.industries-block').addClass('active');
  }

  function updateSliderImages() {
    const windowWidth = $(window).width();

    $('.slider-images .image').each(function () {
      const $img = $(this);
      const desktopLSrc = $img.data('src-desktop-l');
      const desktopMSrc = $img.data('src-desktop-m');
      const tabletLSrc = $img.data('src-tablet-l');
      const tabletMDSrc = $img.data('src-tablet-m');
      const tabletSMSrc = $img.data('src-tablet-s');
      const mobileSrc = $img.data('src-mobile');

      let newSrc = desktopLSrc;

      if (windowWidth >= 1400) {
        newSrc = desktopLSrc;
      } else if (windowWidth >= 1200 && windowWidth < 1400) {
        newSrc = desktopMSrc;
      } else if (windowWidth >= 992 && windowWidth < 1200) {
        newSrc = tabletLSrc;
      } else if (windowWidth >= 768 && windowWidth < 992) {
        newSrc = tabletMDSrc;
      } else if (windowWidth >= 576 && windowWidth < 768) {
        newSrc = tabletSMSrc;
      } else {
        newSrc = mobileSrc;
      }

      if ($img.attr('src') !== newSrc) {
        $img.attr('src', newSrc);
      }
    });
  }

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this,
          args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  updateSliderImages();

  $(window).on('resize', debounce(updateSliderImages, 200));
});
